import { render, staticRenderFns } from "./TransferOwnershipDialog.vue?vue&type=template&id=22ab2e96"
import script from "./TransferOwnershipDialog.vue?vue&type=script&lang=js"
export * from "./TransferOwnershipDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports